<template>
  <ModalBase @close-modal="$store.dispatch('closeScoringCriteriaModal')">
    <p class="lead">
      5段階評価について
    </p>
    <div class="cnt" :style="{ 'max-height': contentHeight + 'px' }">
      <section class="sec">
        <HeadingLv3 :text="'症例数'" />
        <div class="sec_block">
          <TextBlock>
            <p class="block">
              症例数は年間の入院患者数と外来患者数の合算値の平均値で算出しています。<br />
              全病院平均：428,875人（1,175人/日）
            </p>
            <ul class="notes block">
              <li>
                ※
                臨床研修協議会ホームページに記載がある場合はそちらから引用。<br />
                記載のない場合には各病院様から回収したヒアリングシートの情報から設定しています。
              </li>
              <li>
                ※ 事前に入力した数値を変更される場合は、営業担当にご連絡下さい。
              </li>
            </ul>
          </TextBlock>
        </div>
        <ul class="scoring">
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 1 }" :key="n" />
            </div>
            <p class="scoring_data">～270,000人</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 2 }" :key="n" />
            </div>
            <p class="scoring_data">270,001人～343,000人</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 3 }" :key="n" />
            </div>
            <p class="scoring_data">343,001人～443,000人</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 4 }" :key="n" />
            </div>
            <p class="scoring_data">443,001人～576,000人</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 5 }" :key="n" />
            </div>
            <p class="scoring_data">576,001人～</p>
          </li>
        </ul>
      </section>

      <section class="sec">
        <HeadingLv3 :text="'指導医数'" />
        <div class="sec_block">
          <TextBlock>
            <p class="block">
              （該当割合 ※割合は回収データ0件以外の「409件」から算出）<br />
              指導医数は各病院にご入力頂いた数値の全病院の平均値で設定しています。
            </p>
            <ul class="notes block">
              <li>
                ※ 事前に入力した数値を変更される場合は、営業担当にご連絡下さい。
              </li>
            </ul>
          </TextBlock>
        </div>
        <ul class="scoring">
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 1 }" :key="n" />
            </div>
            <p class="scoring_data">1～10名</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 2 }" :key="n" />
            </div>
            <p class="scoring_data">11～20名</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 3 }" :key="n" />
            </div>
            <p class="scoring_data">21～40名</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 4 }" :key="n" />
            </div>
            <p class="scoring_data">41～60名</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 5 }" :key="n" />
            </div>
            <p class="scoring_data">61名～</p>
          </li>
        </ul>
      </section>

      <section class="sec">
        <HeadingLv3 :text="'給与'" />
        <div class="sec_block">
          <TextBlock>
            <p class="block">
              給与は各病院にご入力いただきました年収から設定しています。
            </p>
            <ul class="notes block">
              <li>
                ※ 事前に入力した数値を変更される場合は、営業担当にご連絡下さい。
              </li>
              <li>
                ※
                エリア特性は加味しておりません。全国一律の条件で定めております。
              </li>
            </ul>
          </TextBlock>
        </div>
        <ul class="scoring">
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 1 }" :key="n" />
            </div>
            <p class="scoring_data">～400万円</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 2 }" :key="n" />
            </div>
            <p class="scoring_data">401万円～</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 3 }" :key="n" />
            </div>
            <p class="scoring_data">501万円～</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 4 }" :key="n" />
            </div>
            <p class="scoring_data">601万円～</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 5 }" :key="n" />
            </div>
            <p class="scoring_data">701万円～</p>
          </li>
        </ul>
      </section>

      <section class="sec">
        <HeadingLv3 :text="'倍率'" />
        <div class="sec_block">
          <TextBlock>
            <p class="block">
              （2020年度中間マッチング 第一志望）<br />
              倍率は2020年度中間マッチングの第一志望の倍率を基準に設定しています。
            </p>
            <ul class="notes block">
              <li>
                ※ 事前に入力した数値を変更される場合は、営業担当にご連絡下さい。
              </li>
            </ul>
          </TextBlock>
        </div>
        <ul class="scoring">
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 1 }" :key="n" />
            </div>
            <p class="scoring_data">0</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 2 }" :key="n" />
            </div>
            <p class="scoring_data">0.1～0.5</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 3 }" :key="n" />
            </div>
            <p class="scoring_data">0.6～1.0</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 4 }" :key="n" />
            </div>
            <p class="scoring_data">1.1～1.5</p>
          </li>
          <li>
            <div class="scoring_icon">
              <span v-for="n in 5" :class="{ 'is-active': n <= 5 }" :key="n" />
            </div>
            <p class="scoring_data">1.6～</p>
          </li>
        </ul>
      </section>
    </div>
  </ModalBase>
</template>

<script lang="ts">
import { ref } from 'vue'
import ModalBase from '@/components/genenral/ModalBase.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import TextBlock from '@/components/block/TextBlock.vue'

export default {
  name: 'ScoringCriteriaModal',

  components: {
    ModalBase,
    HeadingLv3,
    TextBlock
  },

  setup() {
    const contentHeight = ref(0)

    const getContentHeight = () => {
      const h = window.innerHeight
      if (window.innerWidth >= 900) {
        // ページ高さ - モーダルマージン(上) - モーダルマージン(下) - モーダルパディング(上下) - タイトル高さ
        return h - 95 - 80 - 80 - 54
      } else {
        // ページ高さ - モーダルマージン(上) - モーダルマージン(下) - タイトル高さ
        return h - 40 - 40 - 48
      }
    }
    contentHeight.value = getContentHeight()

    window.addEventListener('resize', () => {
      // スマホのツールバーの表示非表示でページ高さがすぐに反映されないときのための対策
      setTimeout(() => {
        contentHeight.value = getContentHeight()
      }, 200)
    })

    return {
      contentHeight
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.lead {
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: var.$color-main;
  height: 48px;

  @include mixins.media() {
    height: 54px;
  }
}

.cnt {
  overflow-y: auto;
  padding-left: 20px;
  padding-right: 20px;

  @include mixins.media() {
    padding-left: 50px;
    padding-right: 50px;
  }
}

.sec {
  &:not(:first-child) {
    margin-top: 24px;
  }

  &_block {
    margin-top: 16px;
  }
}

.scoring {
  margin-top: 24px;

  li {
    display: flex;
    align-items: center;
  }

  &_icon {
    height: 14px;
    display: flex;

    span {
      display: block;
      width: 14px;
      height: 14px;
      margin-left: 3px;
      background-image: url('~@/assets/icon/star.svg');
      background-size: 14px 14px;

      &.is-active {
        background-image: url('~@/assets/icon/star_on.svg');
      }
    }
  }

  &_data {
    margin-left: 8px;

    &::before {
      content: '：';
    }
  }
}
</style>
